// Stored media is either a full URL (http, a local blob: preview, a data: frame) or an S3 key.
export const toMediaUrl = (value) => {
  if (!value) return value;
  return /^(https?:|blob:|data:)/.test(value) ? value : `${process.env.REACT_APP_AWS_URL}/${value}`;
};
